

<app-header></app-header>

<app-presidents></app-presidents>
<app-right-side></app-right-side>


<div class="container" [dir]="direction">
    <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="clients-grid">

                <ul class="cat-list-bg-style align-center sorting-menu">
                    <li class="cat-list__item" data-filter="*">
                        <a routerLink="/executive-committee" class=""> <strong>
							{{'president-consultant.executive_committee' | translate}} </strong> </a>
                    </li>
					<li class="cat-list__item " data-filter=".politics"><a routerLink="/honorable-committee" class="">
						<strong> {{'president-consultant.honorable_committee' | translate}} </strong></a></li>
                    <li class="cat-list__item" data-filter=".natural"><a routerLink="/iffhs-members" class=""><strong>
						{{'president-consultant.iffhs_member' | translate}} </strong></a></li>
                    <li class="cat-list__item active" data-filter=".worlds">
                        <a routerLink="/president-consultant" class="">
                            <strong> {{'president-consultant.president_consultant' | translate}} </strong></a>
                    </li>
					<li class="cat-list__item " data-filter=".animals"><a routerLink="/president-assistants" class="">
						<strong> {{'president-consultant.president_assistant' | translate}}</strong></a></li>
                    <li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/ranking" class="">
                            <strong> {{'president-consultant.ranking' | translate}} </strong> </a>
                    </li>
                    
                </ul>

                <div class="row sorting-container" id="clients-grid-1" data-layout="masonry">

                    <div class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div class="ui-block">

                            <article class="hentry post has-post-thumbnail">
                                <div class="post-thumb">
                                    <img src="../../../assets/img/consultants.jpg" alt="photo" style="width: 100%; height: 380px; margin: 0px auto;">
                                </div>
                            </article>
                        </div>
                    </div>

                    <div class="col col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">

                        <div class="ui-block">

                            <article class="hentry post has-post-thumbnail">
                                <div class="post-thumb">
                                    <img src="../../../assets/img/consultants2.jpeg" alt="photo" style="width: 100%; height: 380px; margin: 0px auto;">
                                </div>
                            </article>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <!-- <app-iffhs-news></app-iffhs-news> -->
    </div>
</div>